// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hr[data-v-0b2bbcee]{margin-top:1rem !important;margin-bottom:1rem !important}.wrapper[data-v-0b2bbcee]{display:flex;flex-direction:row;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.5rem}@media(max-width: 991.98px){.wrapper[data-v-0b2bbcee]{flex-direction:column;align-items:normal}}", ""]);
// Exports
module.exports = exports;
